import styled from 'styled-components';
import Base from './Base';

export const FlexV2 = styled(Base)`
  display: flex;
  ${props => props.jc && `justify-content: ${props.jc};`}
  ${props => props.ai && `align-items: ${props.ai};`}
  ${props => props.fd && `flex-direction: ${props.fd};`}
  ${props => props.ff && `flex-flow: ${props.ff};`}
  ${props => props.fs && `flex-shrink: ${props.fs};`}
  ${props => props.fg && `flex-grow: ${props.fg};`}
  ${props => props.as && `align-self: ${props.as};`}
  ${props => props.order && `order: ${props.order};`}
`;

const Flex = styled.div`
  ${({
    j = 'flex-start',
    a = 'flex-start',
    d = 'row',
    w = 'nowrap',
    full,
    mt = '',
    mr = '',
    mb = '',
    ml = '',
    m = '',
    pt = '',
    pr = '',
    pb = '',
    pl = '',
    p = '',
  }) => `
  display: flex;
  justify-content: ${j};
  align-items: ${a};
  flex-direction: ${d};
  flex-wrap: ${w};
  position: relative;
  ${mt && `margin-top: ${mt};`}
  ${mr && `margin-right: ${mr};`}
  ${mb && `margin-bottom: ${mb};`}
  ${ml && `margin-left: ${ml};`}
  ${m && `margin: ${m};`}
  ${pt && `padding-top: ${pt};`}
  ${pr && `padding-right: ${pr};`}
  ${pb && `padding-bottom: ${pb};`}
  ${pl && `padding-left: ${pl};`}
  ${p && `padding: ${p};`}
  ${full ? 'width: 100%;' : ''}
`}
`;

export default Flex;
